module.exports = __webpack_public_path__ + "img/Carmel_Hospital.44979fbe.svg";